/*
 * This file is part of SketchBand.
 * Copyright (C) 2016  Mikael Brockman
 * 
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 * 
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 * 
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// In this file, t values are measured in fractional bars,
// starting from 0.

var React = require("react")

let clamp = (n, min, max) => Math.min(max, Math.max(min, n))

export let Song = ({
  song,
  t,
  onClickBar,
  beatsPerBar = 4,
  secondsPerBar = 2.4,
}) => {
  var t0 = 0
  return <div
    className="sheet"
    style={{
      "--bar-duration": `${secondsPerBar}s`,
      "--beat-duration": `${secondsPerBar / beatsPerBar}s`,
    }}
  > {
    song.barSequences.map((x, i) => {
      let tag = <BarSequence
        key={`${x.barSequence.name}-${i}-${t0}`}
        onClickBar={onClickBar}
        beatsPerBar={beatsPerBar}
        t0={t0}
        t={t - t0}
        {...x} />
      t0 += x.barSequence.bars.length
      return tag
    })
  } </div>
}

let BarSequence = ({ barSequence, t, t0, onClickBar, beatsPerBar }) =>
  <div className="bar-sequence">
    <div className="bar-sequence-name">{barSequence.name}</div>
    <div className="bar-sequence-bars">
      {barSequence.bars.map(
        (x, i) =>
          <Bar
            key={t0 + i}
            beatsPerBar={beatsPerBar}
            t0={t0 + i}
            t={t - i}
            {...x}
            onClickBar={onClickBar}
          />
       )}
    </div>
  </div>

let Bar = ({ beatsPerBar, t0, t, bar, onClickBar }) => {
  let progress = clamp(t, 0, 1)
  let isActive = t >= 0 && t < 1
  let stateClassName = (
    isActive
      ? "is-active"
      : (t < 0 ? "is-future" : "is-past")
  )

  return <div
       className={`bar-shell ${stateClassName}`}
       data-bar-number={t0}
       onMouseDown={onClickBar ? () => onClickBar(t0) : undefined}
  >
    {isActive ? <Pixie progress={progress} /> : null}
    <div className={`bar ${isActive ? "playing" : ""}`}>
      <div className="bar-voices">
        {bar.voices.map((x, i) => <Voice key={i} t={t} voice={x}/>)}
      </div>
      <BarProgress progress={progress} isActive={isActive} isPast={t >= 1} />
    </div>
  </div>
}

let Voice = ({ t, voice }) =>
  <div className="voice">
    {voice.harmony ? <Harmony {...voice}/> : (
       voice.lyric ? <Lyric {...voice}/> : null
     )}
  </div>

let Harmony = ({ harmony }) =>
  <div className="harmony">
    {harmony.chords.map((x, i) => <Chord key={`${x.chord.name}-${i}`} {...x}/>)}
  </div>

let Lyric = ({ lyric }) =>
  <div className="lyric"> {lyric.text} </div>

let Chord = ({ chord }) =>
  <div className="chord"> {chord.name} </div>

let BarProgress = ({ progress, isActive, isPast }) =>
  <div className="bar-progress-rail">
    <div
      className={`bar-progress-fill ${isActive ? "is-active" : ""}`}
      style={{
        width: `${(isPast ? 1 : progress) * 100}%`
      }}
    />
  </div>

let Pixie = ({ progress }) =>
  <div className="bar-pixie-track" aria-hidden="true">
    <div
      className="bar-pixie"
      style={{
        left: `calc(${progress * 100}% - 0.4rem)`,
        animationDuration: "var(--bar-duration)",
      }}
    />
  </div>
